import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["relative flex flex-col xl:flex-row group/1", $props.classes])
  }, [
    _renderSlot(_ctx.$slots, "image", { click: $options.play }),
    _renderSlot(_ctx.$slots, "text", { uniqueRef: $data.uniqueRef })
  ], 2))
}